// components/PrivateRoute.js
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ token, roles, allowedRoles = [], children }) => {
  if (!token) {
    return <Navigate to="/" replace />;
  }

  if (allowedRoles.length === 0) {
    return children; // acceso libre mientras tenga token
  }

  const hasPermission = roles.some(role => allowedRoles.includes(role));
  return hasPermission ? children : <Navigate to="/" replace />;
};

export default PrivateRoute;
